/*
 * ATTENTION: This file was automatically created by RADPresentation.HTMLClient.Generator
 */

import { container } from "tsyringe";
import * as DTO from "coreframetypings/dto";

export interface IRADEnvironmentProxy {
    clientAction: KnockoutObservable<{ operation: string, args: any }>;
    whenAllRequestsAreResponded(): JQuery.Promise<null>;
    hasActiveServerCommunication(): boolean;

    applyDetailViewContext(args: {
        detailViewContextID: string,
        values: Object
    })
        : JQueryDeferred<DTO.IValidationDTO>;

    aquireExclusiveLock(args: {
        detailViewContextID: string
    })
        : JQueryDeferred<DTO.IResultDTO>;

    aquireLockObject(args: {
        lockGroupID: string,
        pdoID: string
    })
        : JQueryDeferred<boolean>;

    aquireLockObjects(args: {
        lockGroupID: string,
        pdoIds: Array<number>
    })
        : JQueryDeferred<{ [key: string]: boolean }>;

    autoLogout(args: {
        clientInfoID: string
    })
        : JQueryDeferred<boolean>;

    beginTransaction()
        : JQueryDeferred<boolean>;

    callOperation(args: {
        pdoID: string,
        operationName: string,
        operationParameters: Array<any>,
        contextParameters: Object
    })
        : JQueryDeferred<DTO.IOperationResultDTO>;

    callOperationFromDVContext(args: {
        detailViewContextID: string,
        operationName: string,
        operationParameters: Array<any>,
        property_values: Object,
        contextParameters: Object,
        nestedContextName: string,
        withValidation: boolean,
        needsLock?: boolean
    })
        : JQueryDeferred<DTO.IOperationResultDTO>;

    callStaticOperation(args: {
        pdTypeName: string,
        operationName: string,
        operationParameters: Array<any>,
        contextParameters: Object,
        _isWorker?: boolean
    })
        : JQueryDeferred<DTO.IOperationResultDTO>;

    callStaticOperationWithoutTransaction(args: {
        pdTypeName: string,
        operationName: string,
        operationParameters: Array<any>,
        contextParameters: Object
    })
        : JQueryDeferred<DTO.IOperationResultDTO>;

    changeLanguage(args: {
        lang: string
    })
        : JQueryDeferred<DTO.IResultDTO>;

    changePassword(args: {
        oldPassword: string,
        newPassword: string,
        tokenExplicitlyAdded?: boolean
    })
        : JQueryDeferred<DTO.IChangePasswordResponseDTO>;

    changePersistenceContext(args: {
        persistenceContextID: string
    })
        : JQueryDeferred<boolean>;

    changePrincipal(args: {
        principal: string
    })
        : JQueryDeferred<DTO.IPrincipalDTO>;

    commitTransaction()
        : JQueryDeferred<boolean>;

    confirmInlineEditingObjects(args: {
        pdTypeName: string,
        pdoIDs: Array<string>,
        isConfirmed: boolean
    })
        : JQueryDeferred<DTO.IResultDTO>;

    connect(args: {
        pdoID: string,
        assoziationName: string,
        topdTypeName: string,
        toPDOID: string,
        nestedContextName: string
    })
        : JQueryDeferred<DTO.IChangeObjectDTO>;

    connectFromInlineEditing(args: {
        inlineEditingContextId: string,
        targetPdoIds: Array<number>,
        targetPdTypeName: string
    })
        : JQueryDeferred<DTO.IResultDTO>;

    connectMany(args: {
        pdoID: string,
        assoziationName: string,
        topdTypeName: string,
        toPDOIDs: Array<string>,
        nestedContextName: string
    })
        : JQueryDeferred<DTO.IChangeObjectDTO>;

    createAndConnectFromUploadedContent(args: {
        contextPdoId: string,
        contextPdTypeName: string,
        targetPdTypeName: string,
        relationName: string,
        name: string,
        isFile: boolean
    })
        : JQueryDeferred<DTO.IResultDTO>;

    createAndLockInlineEditingObject(args: {
        pdoID: string,
        contextRelationName: string,
        lockGroupID: string,
        initialValues?: Object
    })
        : JQueryDeferred<DTO.IGenericDTO>;

    createDetailViewContext(args: {
        typeName: string,
        pdoID: string,
        acquireLock: boolean,
        contextTypeName: string,
        contextRelationName: string,
        contextParameters: Object
    })
        : JQueryDeferred<DTO.IDetailViewContextDTO>;

    createDetailViewContextAndConnectNew(args: {
        typeName: string,
        contextPDOID: string,
        contextTypeName: string,
        contextRelationName: string,
        contextParameters: Object
    })
        : JQueryDeferred<DTO.IDetailViewContextDTO>;

    createFromInlineEditing(args: {
        inlineEditingContextId: string
    })
        : JQueryDeferred<DTO.ICreatedInlineObjectsDTO>;

    createInlineEditingContext(args: {
        pdTypeName: string,
        contextPdoId: string,
        contextRelationName: string,
        detailViewContextID: string,
        primarySubAssociation: string,
        nestedContextName: string,
        isSummaryViewMode: boolean,
        removeDefaultProperties: boolean,
        acquireLocks?: boolean
    })
        : JQueryDeferred<DTO.IInlineEditingContextDTO>;

    createIterator(args: {
        pdTypeName: string,
        properties: Array<string>,
        filter: string,
        orderby: string,
        retrieveExtentCount: boolean,
        contextPDO_ID: string
    })
        : JQueryDeferred<DTO.IIteratorDTO>;

    createIteratorForAssoziation(args: {
        pdTypeName: string,
        pdo_id: string,
        assoziationName: string,
        properties: Array<string>,
        filter: string,
        orderby: string,
        retrieveExtentCount: boolean,
        itOperator: DTO.IPDIteratorOperatorDTO
    })
        : JQueryDeferred<DTO.IIteratorDTO>;

    createIteratorWithOperator(args: {
        pdTypeName: string,
        properties: Array<string>,
        filter: string,
        orderby: string,
        retrieveExtentCount: boolean,
        contextPDO_ID: string,
        itOperator: DTO.IPDIteratorOperatorDTO
    })
        : JQueryDeferred<DTO.IIteratorDTO>;

    createLockGroup()
        : JQueryDeferred<string>;

    createLogZip(args: {
        days: number
    })
        : JQueryDeferred<DTO.IResultDTO>;

    createPersistenceContext()
        : JQueryDeferred<string>;

    deleteDetailViewContext(args: {
        detailViewContextID: string
    })
        : JQueryDeferred<DTO.IResultDTO>;

    deleteDetailViewContextStack(args: {
        detailViewContextIdStack: Array<string>
    })
        : JQueryDeferred<DTO.IResultDTO>;

    deleteIterator(args: {
        iteratorID: string
    })
        : JQueryDeferred<boolean>;

    deleteIterators(args: {
        iteratorIDs: Array<number>
    })
        : JQueryDeferred<Array<boolean>>;

    deleteLockGroup(args: {
        lockGroupID: string
    })
        : JQueryDeferred<boolean>;

    deleteManyObjects(args: {
        pdTypeName: string,
        pdoIDs: Array<string>
    })
        : JQueryDeferred<DTO.IChangeObjectDTO>;

    deleteObject(args: {
        pdTypeName: string,
        pdoID: string
    })
        : JQueryDeferred<DTO.IChangeObjectDTO>;

    deletePersistenceContext(args: {
        persistenceContextID: string
    })
        : JQueryDeferred<boolean>;

    describeSearchResult(args: {
        pdoId: string
    })
        : JQueryDeferred<{ [key: string]: string }>;

    disconnect(args: {
        pdoID: string,
        assoziationName: string,
        topdTypeName: string,
        toPDOID: string,
        nestedContextName: string
    })
        : JQueryDeferred<DTO.IChangeObjectDTO>;

    disconnectAndDeleteInlineEditingGridRow(args: {
        pdTypeName: string,
        pdoID: string,
        toPDOID: string,
        topdTypeName: string,
        assoziationName: string
    })
        : JQueryDeferred<DTO.IChangeObjectDTO>;

    disconnectFromInlineEditing(args: {
        inlineEditingContextId: string,
        targetPdoIds: Array<number>,
        targetPdTypeName: string
    })
        : JQueryDeferred<DTO.IResultDTO>;

    disconnectMany(args: {
        pdoID: string,
        assoziationName: string,
        topdTypeName: string,
        toPDOIDs: Array<string>,
        nestedContextName: string
    })
        : JQueryDeferred<DTO.IChangeObjectDTO>;

    exportData(args: {
        iteratorID: string,
        exportType: any,
        columns: Array<string>,
        filter: string,
        showFilter?: boolean
    })
        : JQueryDeferred<string>;

    flushErrorMessages()
        : JQueryDeferred<{ [key: string]: Array<string> }>;

    getActivityFeed(args: {
        itemAmount: number,
        language: string
    })
        : JQueryDeferred<DTO.IActivityFeedDTO>;

    getAggregationExtent(args: {
        iteratorID: string,
        aggregation: DTO.IIteratorAggregationDTO
    })
        : JQueryDeferred<any>;

    getAllResourceItems(args: {
        lang: string
    })
        : JQueryDeferred<{ [key: string]: string }>;

    getApplication()
        : JQueryDeferred<DTO.IApplicationDTO>;

    getAssignedPrincipals(args: {
        username: string
    })
        : JQueryDeferred<DTO.IAssignedPrincipalsDTO>;

    getAvailableSearchParameters()
        : JQueryDeferred<DTO.ISearchParameterDTO>;

    getCurrentUserTaskInfo()
        : JQueryDeferred<DTO.ITaskInformationDTO>;

    getDetailView(args: {
        pdoID: string
    })
        : JQueryDeferred<DTO.IDetailViewDTO>;

    getExtent(args: {
        iteratorID: string,
        start: number,
        end: number
    })
        : JQueryDeferred<any>;

    getExtentCount(args: {
        iteratorID: string
    })
        : JQueryDeferred<string>;

    getExtentWithPDOIDAsFirstColumn(args: {
        iteratorID: string,
        start: number,
        end: number
    })
        : JQueryDeferred<any>;

    getInlineEditingObjects(args: {
        inlineEditingContextId: string,
        iteratorId: string,
        properties: Array<string>,
        start: number,
        end: number
    })
        : JQueryDeferred<DTO.IInlineEditingContextDataDTO>;

    getListView(args: {
        listViewPDO_ID: string
    })
        : JQueryDeferred<DTO.IListViewDTO>;

    getListViewByName(args: {
        listViewName: string
    })
        : JQueryDeferred<DTO.IListViewDTO>;

    getListViewByObject(args: {
        listViewName: string,
        pdoID: string
    })
        : JQueryDeferred<DTO.IListViewDTO>;

    getListViewForFilter(args: {
        listViewPDO_ID: string
    })
        : JQueryDeferred<DTO.IListViewDTO>;

    getMenuImagesSprite()
        : JQueryDeferred<DTO.IImageSpriteDTO>;

    getMenuTree()
        : JQueryDeferred<DTO.INavigationNodeDTO>;

    getNavigationTree()
        : JQueryDeferred<DTO.INavigationNodeDTO>;

    getNotifications()
        : JQueryDeferred<DTO.INotificationsDTO>;

    getObject(args: {
        pdTypeName: string,
        pdoID: string,
        properties: Array<string>
    })
        : JQueryDeferred<DTO.IGenericDTO>;

    getObjectHistoryInformations(args: {
        pdtypename: string,
        pdoID: string
    })
        : JQueryDeferred<DTO.IObjectHistoryInformationsDTO>;

    getObjects(args: {
        iteratorID: string,
        start: number,
        end: number
    })
        : JQueryDeferred<Array<DTO.IGenericDTO>>;

    getPrincipals()
        : JQueryDeferred<Array<DTO.IPrincipalDTO>>;

    getProperties(args: {
        pdoID: string,
        properties: Array<string>
    })
        : JQueryDeferred<DTO.IResultDTO>;

    getPropertiesForDetailViewContext(args: {
        detailViewContextID: string,
        pdoID: string,
        properties: Array<string>
    })
        : JQueryDeferred<DTO.IResultDTO>;

    getPublicUserData(args: {
        key: string
    })
        : JQueryDeferred<string>;

    getResourceItem(args: {
        lang: string,
        resourceName: string
    })
        : JQueryDeferred<string>;

    getResourceItems(args: {
        lang: string,
        resourceNames: Array<string>
    })
        : JQueryDeferred<{ [key: string]: string }>;

    getResourceItemsForPDO(args: {
        lang: string,
        pdo_id: string
    })
        : JQueryDeferred<{ [key: string]: string }>;

    getResourceItemsForType(args: {
        lang: string,
        pdTypeName: string
    })
        : JQueryDeferred<{ [key: string]: string }>;

    getResourceItemsForTypes(args: {
        lang: string,
        pdTypeNames: Array<string>
    })
        : JQueryDeferred<{ [key: string]: { [key: string]: string } }>;

    getSearchExtent(args: {
        start: number,
        end: number
    })
        : JQueryDeferred<DTO.ISearchResultDTO>;

    getSearchSuggestions(args: {
        query: DTO.ISearchQueryDTO
    })
        : JQueryDeferred<DTO.ISearchSuggestionsDTO>;

    getSummaryView(args: {
        pdtypename: string,
        pdoID: string
    })
        : JQueryDeferred<DTO.ISummaryViewContextDTO>;

    keepAlive(args: {
        clientTime: string
    })
        : JQueryDeferred<DTO.IKeepAliveDTO>;

    login(args: {
        username: string,
        password: string,
        principal: string
    })
        : JQueryDeferred<DTO.ILoginDTO>;

    loginEncoded(args: {
        username: string,
        password: string,
        principal: string
    })
        : JQueryDeferred<DTO.ILoginDTO>;

    loginEncoded2(args: {
        username: string,
        password: string,
        principal: string,
        remainSignedIn: boolean
    })
        : JQueryDeferred<DTO.ILoginDTO>;

    loginEncodedWithLanguage(args: {
        username: string,
        password: string,
        principal: string,
        language: string,
        remainSignedIn: boolean,
        tokenExplicitlyAdded?: boolean
    })
        : JQueryDeferred<DTO.ILoginDTO>;

    logout()
        : JQueryDeferred<boolean>;

    newObject(args: {
        pdTypeName: string
    })
        : JQueryDeferred<DTO.IGenericDTO>;

    outputMessage(args: {
        message: string,
        priority: number
    })
        : JQueryDeferred<boolean>;

    refreshDetailViewContext(args: {
        detailViewContextID: string
    })
        : JQueryDeferred<DTO.IDetailViewContextDTO>;

    refreshNestedDetailViewContext(args: {
        parentContextID: string,
        nestedContextName: string,
        typeName: string,
        pdoId: string
    })
        : JQueryDeferred<DTO.IDetailViewContextDTO>;

    registerForAutoTranslation(args: {
        pdTypeName: string,
        pdoId: string,
        propertyName: string,
        originLanguage: string
    })
        : JQueryDeferred<DTO.IResultDTO>;

    releaseLockedInlineEditingObject(args: {
        lockGroupID: string,
        pdoID: string
    })
        : JQueryDeferred<boolean>;

    releaseLockedObject(args: {
        lockGroupID: string,
        pdoID: string
    })
        : JQueryDeferred<boolean>;

    releaseLockedObjects(args: {
        lockGroupID: string,
        pdoIds: Array<number>
    })
        : JQueryDeferred<{ [key: string]: boolean }>;

    rollbackTransaction()
        : JQueryDeferred<boolean>;

    saveObject(args: {
        pdoID: string,
        lockGroupID: string
    })
        : JQueryDeferred<DTO.ISaveResultDTO>;

    saveObjectWithTransferProperties(args: {
        pdoID: string,
        lockGroupID: string,
        values: Object
    })
        : JQueryDeferred<DTO.ISaveResultDTO>;

    search(args: {
        query: DTO.ISearchQueryDTO
    })
        : JQueryDeferred<DTO.ISearchResultDTO>;

    setProperties(args: {
        pdoID: string,
        values: Object
    })
        : JQueryDeferred<DTO.IResultDTO>;

    swap(args: {
        pdoID: string,
        assoziationName: string,
        first: number,
        second: number
    })
        : JQueryDeferred<DTO.IResultDTO>;

    translate(args: {
        originLanguage: string,
        existingTranslations: Object,
        overrideTranslations: boolean
    })
        : JQueryDeferred<DTO.IResultDTO>;

    tryAutoLogin(args: {
        principal: string
    })
        : JQueryDeferred<DTO.ILoginDTO>;

    tryToDeleteObject(args: {
        pdTypeName: string,
        pdoIDs: Array<string>
    })
        : JQueryDeferred<DTO.ITryDeletionDTO>;

    tryToDisconnectObject(args: {
        pdoID: string,
        assoziationName: string,
        topdTypeName: string,
        pdoIDs: Array<string>
    })
        : JQueryDeferred<DTO.ITryDeletionDTO>;

    updateAndValidateProperties(args: {
        detailViewContextID: string,
        valuesToUpdate: Object,
        valuesToValidate: Array<string>,
        nestedContextName: string
    })
        : JQueryDeferred<DTO.IUpdateAndValidateDTO>;

    updateAndValidatePropertiesInGenericObject(args: {
        pdoID: string,
        lockGroupID: string,
        valuesToUpdate: Object,
        valuesToValidate: Array<string>,
        nestedContextName: string
    })
        : JQueryDeferred<DTO.IUpdateAndValidateDTO>;

    updateClientCache(args: {
        level: any
    })
        : JQueryDeferred<DTO.IClientUpdateDTO>;

    updateProperties(args: {
        pdoID: string,
        values: Object,
        scopedProperties: Array<string>,
        nestedContextName: string
    })
        : JQueryDeferred<DTO.IUpdateDTO>;

    updatePublicUserData(args: {
        key: string,
        value: string
    })
        : JQueryDeferred<boolean>;

    updateUserSpecificData(args: {
        key: string,
        value: string
    })
        : JQueryDeferred<boolean>;
}

export default class RADEnvironmentProxy {
    public static getInstance(): IRADEnvironmentProxy {
        return container.resolve<IRADEnvironmentProxy>("RADEnvironmentProxy");
    }
}